import { useSelector } from "react-redux";

const nonUiPreferences = ["grp-redesign-modal", "grp-redesign-modal-remind-later", "grp-feedback-modal"];

const getUiPreferences = (cookiePreferences) => {
  const uiPreferences = {};

  Object.keys(cookiePreferences).forEach((key) => {
    if (!nonUiPreferences.includes(key)) {
      uiPreferences[key] = cookiePreferences[key];
    }
  });

  return uiPreferences;
};

const getUiOptions = (options) => options.filter((option) => !nonUiPreferences.includes(option.id));

function usePreferences() {
  const allPreferences = useSelector((state) => state.preferences);
  const { options, activeOption } = useSelector((state) => state.prefOptions);
  const uiPreferences = getUiPreferences(allPreferences);
  const uiOptions = getUiOptions(options);

  return {
    preferences: uiPreferences,
    options: uiOptions,
    activeOption,
  };
}

export default usePreferences;
